/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { remoteMcpDeleteServerHeader } from "../funcs/remoteMcpDeleteServerHeader.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteRemoteMcpServerHeaderRequest,
  DeleteRemoteMcpServerHeaderSecurity,
} from "../models/operations/deleteremotemcpserverheader.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DeleteRemoteMcpServerHeaderMutationVariables = {
  request: DeleteRemoteMcpServerHeaderRequest;
  security?: DeleteRemoteMcpServerHeaderSecurity | undefined;
  options?: RequestOptions;
};

export type DeleteRemoteMcpServerHeaderMutationData = void;

export type DeleteRemoteMcpServerHeaderMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteServerHeader remoteMcp
 *
 * @remarks
 * Delete a remote MCP server header
 */
export function useDeleteRemoteMcpServerHeaderMutation(
  options?: MutationHookOptions<
    DeleteRemoteMcpServerHeaderMutationData,
    DeleteRemoteMcpServerHeaderMutationError,
    DeleteRemoteMcpServerHeaderMutationVariables
  >,
): UseMutationResult<
  DeleteRemoteMcpServerHeaderMutationData,
  DeleteRemoteMcpServerHeaderMutationError,
  DeleteRemoteMcpServerHeaderMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDeleteRemoteMcpServerHeaderMutation(client, options),
    ...options,
  });
}

export function mutationKeyDeleteRemoteMcpServerHeader(): MutationKey {
  return ["@gram/client", "remoteMcp", "deleteServerHeader"];
}

export function buildDeleteRemoteMcpServerHeaderMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DeleteRemoteMcpServerHeaderMutationVariables,
  ) => Promise<DeleteRemoteMcpServerHeaderMutationData>;
} {
  return {
    mutationKey: mutationKeyDeleteRemoteMcpServerHeader(),
    mutationFn: function deleteRemoteMcpServerHeaderMutationFn({
      request,
      security,
      options,
    }): Promise<DeleteRemoteMcpServerHeaderMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(remoteMcpDeleteServerHeader(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
